/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

// @store
import { useCompanyStore } from "../../../store/useCompanyStore";
import { useSpinnerStore } from "../../../store/useSpinnerStore";
import useServiceRequestStore from '../../../store/useServiceRequestStore';

// @services
import statisticService from "../../../services/statistic.service";
import profileService from "../../../services/profile.service";

// @components
import UpgradeCard from "./components/UpgradeCard";
import SatisfactionGraph from "./components/SatisfactionGraph";
import UserProfile from "./components/UserProfile";
import ActiveServices from "./components/ActiveServices";
import TopServices from './components/TopServices';

// @types
import { Statistic } from "../../../types/statistic.types";
import { RequestFilters } from "../../../types/request.types";

export default function Dashboard() {
  const { t } = useTranslation();
  const { data } = useCompanyStore();
  const { openSpinner } = useSpinnerStore();
  const { fetchActiveForProfessional, activeForProfessional } = useServiceRequestStore();
  const [logo, setLogo] = useState('');
  const [topServicesList, setTopServicesList] = useState<number[]>([])
  const [statistic, setStatistic] = useState<Statistic | undefined>();

  const getLogoForCompany = async () => {
    if (!data?.companyLogoId) return;
    openSpinner(true);
    try {
      await profileService.getLogoForCompany(data?.companyLogoId ?? '').then((response: any) => {
        return setLogo(response);
      })
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      setLogo("");
      toast.error(t("error.callList"));
    }
  }

  const getStatistic = async () => {
    openSpinner(true);
    try {
      const response = await statisticService.getStatistics(data?.professionalId ?? '');
      setStatistic(response);
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  }

  useEffect(() => {
    const params: RequestFilters = {
      pageNumber: 1,
      pageSize: 100
    }
    fetchActiveForProfessional(params);
  }, [fetchActiveForProfessional]);

  useEffect(() => {
    getLogoForCompany();
    getStatistic();
    setTopServicesList([1, 2, 3]);
  }, [])

  return (
    <div className="grid grid-cols-1 gap-4 h-[100vh] pb-[20px] overflow-auto">
      <div className="bg-white dark:bg-dark-cBackground rounded-lg shadow-sm p-6 flex flex-col 2xl:flex-row gap-6 ">
        <UserProfile
          logo={logo}
          statistics={statistic}
        />
        <ActiveServices activeServices={activeForProfessional} />
      </div>

      {/* Remaining Cards */}
      <div className="grid grid-cols-1 2xl:grid-cols-[1fr,1fr] gap-4">
        <UpgradeCard />
        <div className="w-full flex flex-col lg:flex-row gap-4">
          <SatisfactionGraph />
          <TopServices topServicesList={topServicesList} />
        </div>
      </div>
      <div className="w-full h-[50px]"></div>
    </div>
  );
}
